// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-bg: var(--card-bg);
  --footer-border: var(--border);
  --footer-text: var(--text-secondary);
  --footer-link: var(--primary);
  --footer-link-hover: var(--primary-hover);
  --footer-divider: var(--border);
}

.epw-site-footer {
  width: 100%;
  background: var(--footer-bg);
  border-top: 1px solid var(--footer-border);
  color: var(--footer-text);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  margin-top: auto;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.epw-site-footer-inner {
  width: min(100% - 36px, 1120px);
  min-height: 62px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
  text-align: center;
  font-size: 0.88rem;
}

.epw-site-footer a {
  color: var(--footer-link);
  font-weight: 700;
  text-decoration: none;
}
.epw-site-footer a:hover,
.epw-site-footer a:focus-visible {
  color: var(--footer-link-hover);
  text-decoration: underline;
  text-underline-offset: 3px;
  outline: none;
}
.epw-site-footer a::before {
  content: "|";
  color: var(--footer-divider);
  margin-right: 18px;
  font-weight: 400;
}

@media (max-width: 620px) {
  .epw-site-footer-inner {
    min-height: 74px;
    gap: 8px 12px;
    font-size: 0.82rem;
  }
  .epw-site-footer a::before {
    margin-right: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteFooter.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,0CAA0C;EAC1C,yBAAyB;EACzB,uGAAuG;EACvG,gBAAgB;EAChB,yEAAyE;AAC3E;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[":root {\n  --footer-bg: var(--card-bg);\n  --footer-border: var(--border);\n  --footer-text: var(--text-secondary);\n  --footer-link: var(--primary);\n  --footer-link-hover: var(--primary-hover);\n  --footer-divider: var(--border);\n}\n\n.epw-site-footer {\n  width: 100%;\n  background: var(--footer-bg);\n  border-top: 1px solid var(--footer-border);\n  color: var(--footer-text);\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  margin-top: auto;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.epw-site-footer-inner {\n  width: min(100% - 36px, 1120px);\n  min-height: 62px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  flex-wrap: wrap;\n  text-align: center;\n  font-size: 0.88rem;\n}\n\n.epw-site-footer a {\n  color: var(--footer-link);\n  font-weight: 700;\n  text-decoration: none;\n}\n.epw-site-footer a:hover,\n.epw-site-footer a:focus-visible {\n  color: var(--footer-link-hover);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  outline: none;\n}\n.epw-site-footer a::before {\n  content: \"|\";\n  color: var(--footer-divider);\n  margin-right: 18px;\n  font-weight: 400;\n}\n\n@media (max-width: 620px) {\n  .epw-site-footer-inner {\n    min-height: 74px;\n    gap: 8px 12px;\n    font-size: 0.82rem;\n  }\n  .epw-site-footer a::before {\n    margin-right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
